import { render, staticRenderFns } from "./createterminal.vue?vue&type=template&id=9b8f7d82"
import script from "./createterminal.vue?vue&type=script&lang=js"
export * from "./createterminal.vue?vue&type=script&lang=js"
import style0 from "./createterminal.vue?vue&type=style&index=0&id=9b8f7d82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports